import styled from '@emotion/styled';

export const MarkerDetailWrapper = styled('div')(() => ({
  borderRadius: '10px',
  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
  overflow: 'hidden',
  margin: '10px',
  cursor: 'pointer',
  width: '95%',
  position: 'relative',
}));
